import { defineStore } from 'pinia'
import { ref } from 'vue'
import { fetchActiveMenus } from '@/services/menuService'

export const useMenuStore = defineStore('menu', () => {
    const menus = ref({})
    const flatMenus = ref([])

    async function loadMenus() {
        try {
            const response = await fetchActiveMenus()
            const rawMenus = response.data || {}

            // 🔐 Sanitiza para asegurar que todos los valores sean arrays
            const sanitizedMenus = {}
            for (const key in rawMenus) {
                const value = rawMenus[key]
                sanitizedMenus[key] = Array.isArray(value) ? value : []
            }
            menus.value = sanitizedMenus
            flatMenus.value = Object.values(sanitizedMenus).flat()
        } catch (e) {
            console.error('Error al cargar menús:', e)
            menus.value = {}
            flatMenus.value = []
        }
    }


    return {
        menus,
        flatMenus,
        loadMenus
    }
})
